// @index(['./!(*.spec).ts', './*/index.ts'], f => `export * from '${f.path.replace(/\/index$/, '')}';`)
export * from './company-access.model';
export * from './company-config.model';
export * from './company-entity.model';
export * from './company.model';
export * from './invitation.model';
export * from './company-template-signature.model';
export * from './company-template.model';
// @endindex